declare global {
  interface Number {
    toRound(): number;
  }
}

Number.prototype.toRound = function (): number {
  // @ts-ignore
  return Math.round(this * 100) / 100;
};

export {};
